export const form_value = {
  textarea: "How can an automotive supplier reduce its inventory by increasing transparency in its inventory projection?",
  days: "1",
  hours: "4",
};
